import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-vittaa-typo",
  templateUrl: "./vittaa-typo.component.html",
  styleUrls: ["./vittaa-typo.component.scss"],
})
export class VittaaTypoComponent implements OnInit {
  colours = [
    {
      swatch: "#23D93D",
      title: "Mantis",
      code: "#23D93D",
    },
    {
      swatch: "#4B296B",
      title: "Blue Diamond",
      code: "#4B296B",
    },
    {
      swatch: "#FDFEFD",
      title: "Smoke White",
      code: "#FDFEFD",
    },
  ];

  constructor() {}

  ngOnInit() {}
}
